/**
 * @generated SignedSource<<0346bd5ce3beee659ba1e81f574c51da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endts"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invoiceNumber"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relatedAccount"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startts"
},
v9 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "endts",
        "variableName": "endts"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "invoicenumber",
        "variableName": "invoiceNumber"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "orderby",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "orderdirection",
        "variableName": "orderDirection"
      },
      {
        "kind": "Variable",
        "name": "relatedaccount",
        "variableName": "relatedAccount"
      },
      {
        "kind": "Variable",
        "name": "startts",
        "variableName": "startts"
      }
    ],
    "concreteType": "InvoiceDocumentsConnection",
    "kind": "LinkedField",
    "name": "getdocumentinvoices",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceDocument",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relatedAccountName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerDocumentsInvoicesQuery",
    "selections": (v9/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResellerDocumentsInvoicesQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "807adc1a51e7b3c5323c108b9fca805d",
    "id": null,
    "metadata": {},
    "name": "ResellerDocumentsInvoicesQuery",
    "operationKind": "query",
    "text": "query ResellerDocumentsInvoicesQuery(\n  $accountId: UUID!\n  $relatedAccount: String!\n  $invoiceNumber: String!\n  $startts: Datetime\n  $endts: Datetime\n  $orderBy: Int\n  $orderDirection: Int\n  $first: Int\n  $offset: Int\n) {\n  getdocumentinvoices(accountid: $accountId, relatedaccount: $relatedAccount, invoicenumber: $invoiceNumber, startts: $startts, endts: $endts, orderby: $orderBy, orderdirection: $orderDirection, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      invoiceId\n      invoiceDate\n      invoiceNumber\n      invoiceDescription\n      relatedAccountName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6880a95d4102c4668cb313e74ad40d65";

module.exports = node;
